import { IconPlus } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t } from '../../i18n';

// Send work's two buttons on the card (#6770, prototype sendBtn, `:2275-2278`, and the
// simplified card's `.cmp-acts`, `:2402-2403`): a plus and "Send" in the Now header (named
// "Send work to this machine"), a plus and "Send work" on the simplified card. On an offline
// machine both are `aria-disabled`, say why in their `title`, and open nothing.

export function SendWorkButton(props: {
  readonly variant: 'now' | 'simple';
  readonly offline: boolean;
  readonly expanded: boolean;
  readonly onOpen: () => void;
}): JSX.Element {
  return (
    <button
      type="button"
      class="mission-send__open"
      data-variant={props.variant}
      aria-label={props.variant === 'now' ? t('fleet.send.title') : undefined}
      aria-expanded={props.expanded}
      aria-disabled={props.offline ? 'true' : undefined}
      title={t(props.offline ? 'fleet.send.offline_title' : 'fleet.send.title')}
      onClick={() => {
        if (!props.offline) props.onOpen();
      }}
    >
      <IconPlus />
      {t(props.variant === 'now' ? 'fleet.send.send' : 'fleet.send.label')}
    </button>
  );
}
